export default "__VITE_ASSET__bVDldZR7__"